import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import {
  getRetreatTypes,
} from "../../../services/retreatTypeService";

import {
  getRetreats,
} from "../../../services/retreatService";
import {
  BannerSection,
  TransformSection,
  IncludedSection,
  Timeline,
  RetreatCard,
} from "../../../components/template";

const RetreatType = () => {
  const { type } = useParams();

  // ==============================
  // CMS DATA
  // ==============================
const [cmsData, setCmsData] = useState(null);
const [retreats, setRetreats] = useState([]);
const [loading, setLoading] = useState(true);

useEffect(() => {
  loadPage();
}, [type]);

const loadPage = async () => {
  
  try {
    setLoading(true);

    const [typesRes, retreatsRes] = await Promise.all([
      getRetreatTypes(),
      getRetreats(),
    ]);

    const retreatType = typesRes.data.find(
      (item) =>
        item.route?.trim().toLowerCase() ===
        type?.trim().toLowerCase()
    );

    setCmsData(retreatType || null);

const filtered = retreatsRes.data
  .filter(
    (item) =>
      item.retreatType?.route?.toLowerCase() ===
        type?.toLowerCase() &&
      item.status?.toLowerCase() === "published"
  )
  .map((item) => ({
    id: item.id,
    image: item.cardImage,
    date: `${item.startDate} - ${item.endDate}`,
    place: item.location,
    price: `₹${item.startingPrice}`,
    link: `/${type}/${item.id}`,
  }));

setRetreats(filtered);  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};// ==============================
  // Banner Section
  // ==============================
if (loading) {
  return (
    <div className="py-40 text-center">
      Loading...
    </div>
  );
}

if (!cmsData) {
  return (
    <div className="py-40 text-center">
      <h1 className="text-4xl font-bold">
        Retreat Not Found
      </h1>

      <p className="mt-3 text-gray-500">
        No retreat type found for "{type}"
      </p>
    </div>
  );
}
  const heading = (
    <span className="inline-block pl-6 md:pl-20">
      Experience Highlights
    </span>
  );

  const features =
    cmsData.experienceHighlights?.map(
      (item) => ({
        icon: "✨",
        heading: item,
        text: "",
      })
    ) || [];

  // ==============================
  // Transform Section
  // ==============================

  const transformHeading =
    "What You'll Gain";

const transformImage = cmsData?.gainsImage || "";
  const transformPoints =
    cmsData.gains || [];

  const ticons = [
    "🔥",
    "🌊",
    "💡",
    "🚀",
    "🧘",
    "🌟",
    "💪",
  ];

  // ==============================
  // Included Section
  // ==============================

  const whatsIncludedHeading =
    "Experience Highlights";

const whatsIncludedMainImage =
  cmsData?.highlightsImage || "";
  const whatsIncludedItems =
    cmsData.experienceHighlights?.map(
      (item) => ({
        icon: "✨",
        title: item,
      })
    ) || [];

  // ==============================
  // Timeline (temporary)
  // ==============================

  const journey = [
    {
      day: "Day 1",
      title: "Arrival",
      activities: ["Activities from CMS later"],
    },
    {
      day: "Day 2",
      title: "Transformation",
      activities: ["Activities from CMS later"],
    },
    {
      day: "Day 3",
      title: "Integration",
      activities: ["Activities from CMS later"],
    },
    {
      day: "Day 4",
      title: "Completion",
      activities: ["Activities from CMS later"],
    },
  ];

  return (
    <>
      {/* ================= HERO ================= */}

      <section className="relative overflow-hidden bg-[#F7F1EA] py-20">

        <div className="absolute top-0 right-0 w-[420px] h-[420px] bg-[#EBC8A8]/20 rounded-full blur-3xl" />

        <div className="absolute bottom-0 left-0 w-[340px] h-[340px] bg-[#DDBA99]/15 rounded-full blur-3xl" />

        <div className="relative max-w-[1320px] mx-auto px-6">

          <div className="grid grid-cols-1 lg:grid-cols-[1fr_.95fr] gap-14 items-center">

            {/* LEFT */}

            <div>

              <h1
                className="text-[clamp(44px,7vw,84px)] leading-[.92] tracking-[-0.05em] text-secondary"
              >
{cmsData.typeName?.toUpperCase()}              </h1>

              <h2
                className="text-[clamp(30px,4vw,48px)] text-primary mt-6"
              >
                {cmsData.heroTitle}
              </h2>

              <p
                className="mt-8 text-[#5F5751] leading-8"
              >
                {cmsData.heroDescription}
              </p>

              <div className="flex gap-4 mt-10">

                <div className="bg-white px-5 py-3 rounded-full shadow">
                  ⏳ {cmsData.duration}
                </div>

                <div className="bg-white px-5 py-3 rounded-full shadow">
                  🌱 {cmsData.level}
                </div>

              </div>

            </div>

            {/* RIGHT */}

            <div>

              <img
                src={cmsData.heroImage}
                alt={cmsData.typeName}
                className="rounded-[38px] w-full h-[540px] object-cover shadow-xl"
              />

            </div>

          </div>

        </div>

      </section>

      {/* ================= UPCOMING ================= */}

      <section className="py-16 bg-cream">

        <div className="max-w-5xl mx-auto">

          <div className="text-center mb-10">

            <span className="pl-label">
              Join Us
            </span>

            <h2 className="font-heading text-4xl mt-3">
              Upcoming Retreats
            </h2>

          </div>

          <div className="flex flex-col gap-6">

            {retreats.length === 0 ? (
              <div className="text-center py-20">
                No Retreats Available
              </div>
            ) : (
retreats.map((retreat) => (
  <RetreatCard
    key={retreat.id}
    image={retreat.image}
    date={retreat.date}
    place={retreat.place}
    price={retreat.price}
    link={retreat.link}
  />
))         )}

          </div>

        </div>

      </section>

      {/* ================= EXPERIENCE ================= */}

      <BannerSection
        heading={heading}
        features={features}
      />

      {/* ================= GAINS ================= */}

      <TransformSection
        imageSrc={transformImage}
        heading={transformHeading}
        points={transformPoints}
        ticons={ticons}
      />

      {/* ================= HIGHLIGHTS ================= */}

      <IncludedSection
        heading={whatsIncludedHeading}
        mainImage={whatsIncludedMainImage}
        overlayImage=""
        items={whatsIncludedItems}
      />

      {/* ================= TIMELINE ================= */}

      {/* <Timeline journey={journey} /> */}
    </>
  );
};

export default RetreatType;